/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReadNotificationCommandResult } from '../../models/read-notification-command-result';

export interface ApiNotificationCenterReadNotificationGet$Plain$Params {
  NotificationId?: string;
}

export function apiNotificationCenterReadNotificationGet$Plain(http: HttpClient, rootUrl: string, params?: ApiNotificationCenterReadNotificationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ReadNotificationCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNotificationCenterReadNotificationGet$Plain.PATH, 'get');
  if (params) {
    rb.query('NotificationId', params.NotificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReadNotificationCommandResult>;
    })
  );
}

apiNotificationCenterReadNotificationGet$Plain.PATH = '/api/NotificationCenter/ReadNotification';
